import { useState } from 'react';

interface Testimonial {
  name: string;
  role: string;
  event: string;
  text: string;
  rating: number;
  image: string;
}

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials: Testimonial[] = [
    {
      name: 'Mariana & Rafael',
      role: 'Noivos',
      event: 'Casamento ',
      text: 'A Feel Music transformou nosso casamento em um sonho! O Coral Mozart na cerimônia nos emocionou até as lágrimas, e a Banda M7 fez todos dançarem a noite inteira. Simplesmente perfeito!',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/25fe494dcde510e0566514db4a8d4318.jpg'
    },
    {
      name: 'Carolina Mendes',
      role: 'Gerente de Marketing',
      event: 'Corporativo',
      text: 'Contratamos a Feel Music para nossa campanha de Natal e o resultado superou todas as expectativas. O Villa Voice criou uma atmosfera mágica que encantou nossos clientes. Profissionalismo impecável!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20in%20elegant%20corporate%20attire%20smiling%20confidently%2C%20modern%20office%20background%2C%20warm%20professional%20lighting%2C%20sophisticated%20and%20approachable%20demeanor%2C%20executive%20portrait%20photography%2C%20premium%20business%20setting&width=400&height=400&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'Eduardo Santos',
      role: 'Diretor de Eventos',
      event: 'Congresso Corporativo 2023',
      text: 'Trabalho com eventos há 15 anos e posso afirmar: a Feel Music é referência em excelência. A curadoria musical foi perfeita para nosso público executivo. Recomendo de olhos fechados!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Distinguished%20businessman%20in%20formal%20suit%20smiling%20professionally%2C%20corporate%20executive%20portrait%2C%20confident%20and%20successful%20demeanor%2C%20modern%20business%20environment%2C%20warm%20professional%20lighting%2C%20premium%20corporate%20photography&width=400&height=400&seq=testimonial-003&orientation=squarish'
    },
    {
      name: 'Juliana Ferreira',
      role: 'Noiva',
      event: 'Casamento - Outubro 2023',
      text: 'Desde o primeiro contato até o último acorde, a Feel Music foi impecável. A atenção aos detalhes e o carinho com que trataram nosso evento fizeram toda a diferença. Nossos convidados não param de elogiar!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20bride%20in%20elegant%20white%20wedding%20dress%20smiling%20radiantly%2C%20soft%20romantic%20lighting%2C%20sophisticated%20bridal%20portrait%2C%20joyful%20and%20emotional%20expression%2C%20luxury%20wedding%20photography%2C%20warm%20golden%20tones%2C%20premium%20bridal%20setting&width=400&height=400&seq=testimonial-004&orientation=squarish'
    },
    {
      name: 'Roberto Almeida',
      role: 'Produtor Cultural',
      event: 'Festival de Música 2023',
      text: 'A versatilidade da Feel Music é impressionante. Conseguem transitar do clássico ao contemporâneo com maestria. Músicos de altíssimo nível e uma produção que não deixa nada a desejar.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Creative%20professional%20man%20in%20smart%20casual%20attire%20smiling%20warmly%2C%20artistic%20and%20cultural%20background%2C%20confident%20and%20friendly%20demeanor%2C%20modern%20professional%20portrait%2C%20warm%20natural%20lighting%2C%20sophisticated%20setting&width=400&height=400&seq=testimonial-005&orientation=squarish'
    },
    {
      name: 'Patrícia & Lucas',
      role: 'Noivos',
      event: 'Casamento - Novembro 2023',
      text: 'Queríamos algo único e especial, e a Feel Music entregou muito além do esperado. A energia da Banda M7 foi contagiante! Nosso casamento virou assunto entre todos os amigos.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Happy%20newlywed%20couple%20in%20elegant%20wedding%20attire%20embracing%20and%20smiling%2C%20romantic%20golden%20hour%20lighting%2C%20joyful%20and%20loving%20expression%2C%20luxury%20wedding%20photography%2C%20sophisticated%20formal%20wear%2C%20warm%20emotional%20atmosphere&width=400&height=400&seq=testimonial-006&orientation=squarish'
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-24 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-500 font-semibold text-sm uppercase tracking-wider">Depoimentos</span>
          <div className="w-20 h-1 bg-amber-500 mx-auto mt-2 mb-6"></div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Histórias que Emocionam
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Veja o que nossos clientes têm a dizer sobre suas experiências com a Feel Music
          </p>
        </div>

        {/* Main Testimonial */}
        <div className="relative max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 md:p-16 shadow-2xl border border-amber-500/20">
            {/* Quote Icon */}
            <div className="absolute top-8 left-8 text-amber-500/20">
              <i className="ri-double-quotes-l text-6xl"></i>
            </div>

            {/* Content */}
            <div className="relative">
              {/* Stars */}
              <div className="flex gap-1 mb-6 justify-center">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-2xl text-amber-500"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-2xl md:text-3xl text-white text-center leading-relaxed mb-8 font-light italic">
                "{currentTestimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center justify-center gap-6">
                <img
                  src={currentTestimonial.image}
                  alt={currentTestimonial.name}
                  className="w-20 h-20 rounded-full object-cover border-4 border-amber-500"
                />
                <div className="text-left">
                  <h4 className="text-xl font-bold text-white">{currentTestimonial.name}</h4>
                  <p className="text-amber-500 font-semibold">{currentTestimonial.role}</p>
                  <p className="text-gray-400 text-sm">{currentTestimonial.event}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 w-14 h-14 flex items-center justify-center bg-gradient-to-r from-amber-500 to-yellow-600 rounded-full text-white transition-all duration-300 hover:scale-110 hover:shadow-xl cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-line text-2xl"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 w-14 h-14 flex items-center justify-center bg-gradient-to-r from-amber-500 to-yellow-600 rounded-full text-white transition-all duration-300 hover:scale-110 hover:shadow-xl cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center gap-3 mt-12">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentIndex
                  ? 'bg-amber-500 w-8'
                  : 'bg-gray-600 hover:bg-gray-500'
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>

        {/* Thumbnail Grid */}
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4 mt-16 max-w-4xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`relative rounded-xl overflow-hidden transition-all duration-300 cursor-pointer ${
                index === currentIndex
                  ? 'ring-4 ring-amber-500 scale-110'
                  : 'opacity-50 hover:opacity-100'
              }`}
            >
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-full h-full object-cover aspect-square"
              />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
